import { Layout } from "../components/section";
import { Outlet } from "react-router-dom";
import { PageHeader } from "../components/header";

export const Contacts = () => {
  return (
    <>
      <PageHeader title="Message" />
      <Layout>
        <Outlet />
      </Layout>
    </>
  );
};

export default Contacts;
